<div class="modal__header">
  <span class="title">{{ title }}</span>
  <div class="modal-close color-gray-dark" (click)="activeModal.dismiss()"></div>
</div>
<div class="modal__body">
  <app-message [type]="'error'">
    <div message-content *ngFor="let error of errors; let last = last" [ngClass]="{ 'mb-8': !last }">
      <div class="font-weight-bold">Район: {{ error.districtName }}</div>
      <div class="mb-4">Тип работ: {{ error.workTypeName }}</div>
      <div class="color-red">{{ error.message }}</div>
    </div>
  </app-message>
</div>
<div class="modal__footer">
  <div class="modal__footer-action">
    <button class="button" type="button" (click)="activeModal.dismiss()">Закрыть</button>
  </div>
</div>
